var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"border bg-white rounded-lg w-full p-4 shadow-sm max-w-4xl"},[_c('p',{staticClass:"text-gray-700 dark:text-gray-200 mb-4"},[_vm._v(_vm._s(_vm.name))]),_vm._v(" "),_vm._t("default",null,{"value":_vm.value})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }